module.exports = __webpack_public_path__ + "static/img/invite_now.5269210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/invite_now.png
// module id = l5Ka
// module chunks = 0